import Cookies from "js-cookie";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Logo from "../../assets/img/logo.svg";
import Navbar from "../navbar/Navbar";

const HeaderMain = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const [isLogin, setIsLogin] = useState(!!Cookies.get("token"));

  const handleLogout = () => {
    Cookies.remove("token", { path: "/" });
    Cookies.remove("user", { path: "/" });

    setIsLogin(false);
    navigate("/login");
  };

  useEffect(() => {
    setIsLogin(!!Cookies.get("token"));
  }, []);

  return (
    <section id="header">
      <header className="relative bg-gray-50 border-dashed border-2 rounded-2xl mx-auto max-w-7xl px-4 mt-3">
        <div className="mx-auto max-w-7xl px-4">
          <div className="grid grid-cols-2 md:grid-cols-3 items-center h-16">
            <div className="flex justify-start">
              <Link to="/" className="text-teal-600">
                <img src={Logo} alt="Marikerja" className="h-8 w-auto" />
              </Link>
            </div>

            <div className="hidden md:flex justify-center">
              <Navbar />
            </div>

            <div className="flex justify-end items-center gap-3">
              <div className="hidden md:flex gap-4">
                {!isLogin ? (
                  <>
                    <Link
                      to="/login"
                      className="rounded-md bg-indigo-600 px-5 py-2.5 text-sm text-white hover:bg-indigo-950 transition">
                      Login
                    </Link>
                    <Link
                      to="/register"
                      className="rounded-md bg-gray-100 px-5 py-2.5 text-sm text-indigo-600 hover:bg-gray-950 transition">
                      Register
                    </Link>
                  </>
                ) : (
                  <>
                    <Link
                      to="/dashboard"
                      className="rounded-md bg-indigo-600 px-5 py-2.5 text-sm text-white hover:bg-indigo-950 transition">
                      Dashboard
                    </Link>
                    <button
                      onClick={handleLogout}
                      className="rounded-md bg-red-500 px-5 py-2.5 text-sm text-white hover:bg-red-950 transition">
                      Logout
                    </button>
                  </>
                )}
              </div>

              <button
                onClick={() => setOpen(!open)}
                className="md:hidden p-2 rounded hover:bg-gray-100">
                ☰
              </button>
            </div>
          </div>
          {open && (
            <div className="absolute left-0 right-0 top-full z-50 bg-white border rounded-b-2xl shadow-lg md:hidden">
              <div className="p-4">
                <Navbar />

                <div className="mt-4 flex flex-col gap-2 text-center">
                  {!isLogin ? (
                    <>
                      <Link
                        to="/login"
                        className="rounded-md bg-indigo-600 px-5 py-2.5 text-sm text-white hover:bg-indigo-950 transition">
                        Login
                      </Link>
                      <Link
                        to="/register"
                        className="rounded-md bg-gray-100 px-5 py-2.5 text-sm text-indigo-600 hover:bg-gray-950 transition">
                        Register
                      </Link>
                    </>
                  ) : (
                    <>
                      <Link
                        to="/dashboard"
                        className="rounded-md bg-blue-400 px-5 py-2.5 text-sm text-white hover:bg-indigo-950 transition">
                        Dashboard
                      </Link>
                      <button
                        onClick={handleLogout}
                        className="rounded-md bg-red-500 px-5 py-2.5 text-sm text-white hover:bg-red-950 transition">
                        Logout
                      </button>
                    </>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </header>
    </section>
  );
};

export default HeaderMain;
